import { View, Image } from "@/components/ui";
import DefaultImg from "@/assets/images/booking/default-img-1-1.png";
import { Typography } from "../typography";
import { handleOpenLink } from "@/lib/platform";
import { sendAnalyticData } from "@/lib/monitoring/analytics";
import type { BetaServiceName, ServiceName } from "@/types/service";
import { PosthogAnalytics } from "@/lib/monitoring/posthog";
import { useRoute } from "@/components/shared/router";

export type RecommendedBetaService = {
  imageSrc: string;
  title: string;
  url: string;
  betaService?: boolean;
  name: ServiceName | BetaServiceName;
};

export function RecommendedBetaCard({
  imageSrc,
  title,
  url,
  name,
  betaService,
}: RecommendedBetaService) {
  const { push } = useRoute();

  const postHogFlagQueryParam = PosthogAnalytics.getFeatureFlag(
    "complete_booking_service_offer",
  );

  const onClickCard = () => {
    if (betaService) {
      handleOpenLink(
        `${url}&complete_booking_service_offer=${postHogFlagQueryParam}`,
      );
    } else {
      push(url);
    }
    sendAnalyticData({
      name: "view_recommended_service",
      values: { service_type: name },
    });
  };
  return (
    <View
      className="relative flex cursor-pointer flex-col overflow-hidden rounded-xl border border-secondary-border"
      onClick={onClickCard}
    >
      <Image
        src={imageSrc || DefaultImg}
        alt={title}
        className="aspect-square h-auto max-h-[200px] w-full object-cover object-top"
        contentFit="cover"
        style={{ height: undefined, width: "100%", aspectRatio: 1 }}
      />
      <View className="flex flex-col content-between gap-1 p-2">
        <Typography variant="body-md" className="line-clamp-1">
          {title}
        </Typography>
      </View>
    </View>
  );
}
